export default "__VITE_ASSET__BlZ8t_LZ__"